import { render, staticRenderFns } from "./PaymentTypeForm.vue?vue&type=template&id=36260e0c&scoped=true&"
import script from "./PaymentTypeForm.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTypeForm.vue?vue&type=style&index=0&id=36260e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36260e0c",
  null
  
)

export default component.exports